<template>
  <div class="loginContainer clearfix">
      <!-- <img src="./../../assets/img/login/lang.png" alt=""> -->
    <!-- <div class='lang-box' @click="handleLang">
      <div class="select">
        <el-select v-model="lang" placeholder="lang" @change="handleChangeLang">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div> -->
    <canvas id="canvas"></canvas>
    <!-- <div class="login_top">
      <div class="title"><span>基于自主研发传感技术行业应用的物联网平台</span></div>
    </div> -->
    <!-- <div class="left">
      <div class="imgBox">
        <img src="../../assets/img/login/login_left.png" alt="">
      </div>
    </div> -->
    <div class="line-box" :class="iterative ? 'active' : ''">
      <img src="./../../assets/img/login/bg-1.png" alt="">
      <img src="./../../assets/img/login/bg-2.png" alt="">
      <img src="./../../assets/img/login/bg-3.png" alt="">
      <img src="./../../assets/img/login/bg-4.png" alt="">
      <img src="./../../assets/img/login/bg-5.png" alt="">
      <img src="./../../assets/img/login/bg-6.png" alt="">
    </div>

    <div class="login-main-box">
      <login-main></login-main>
    </div>
    
    <div class="footer">
      <p>
        <img src="./../../assets/img/login/bottom-line.png" alt="">
        <span>基于自主研发传感技术行业应用的物联网平台</span>
        <img class="lst" src="./../../assets/img/login/bottom-line.png" alt="">
      </p>
      <!-- 沪ICP备18020687号 -->
      <p>{{versionMsg}}<a class="cNum" href="https://beian.miit.gov.cn" target="_blank">河南威果智能科技有限公司 &nbsp; 沪ICP备18020687号-2</a></p>
      <!-- <p>{{versionMsg}}<a class="cNum" href="https://beian.miit.gov.cn" target="_blank">河南威果智能科技有限公司 &nbsp; 豫ICP备17026398号-3 星图慧连 xingtuhuilian.com </a></p> -->
      <!-- <p>{{versionMsg}}<a class="cNum" href="https://beian.miit.gov.cn/" target="_blank">河南威果智能科技有限公司 &nbsp; 豫ICP备17026398号-3 xingtuhuilian.com</a></p> -->
    </div>

    <!-- <div class="bottom">
      <div class="line"></div>
    </div> -->
    <!-- <div class="company">版权所有&nbsp;©2020-2025&nbsp;河南省汉威智慧消防科技有限公司 技术热线：0371-61779119</div> -->
    <!-- <div class="company">{{versionMsg}}<a class="cNum" href="https://beian.miit.gov.cn" target="_blank">沪ICP备18020687号</a></div> -->
  </div>
</template>

<script>
import loginMain from "@/components/login/loginMain"
import { startBg } from './loginBgStart.js'

export default {
  components:{ loginMain},
  data () {
    return {
      versionMsg:'',
      iterative: false,
      timer_inter: null,
      timer_setTime: null,
      options: [
        { label: '简体中文', value: 'zh-CN' },
        { label: 'русский язык', value: 'rus' }
      ],
      lang: 'zh-CN',
      isLang: false
    }
  },
  computed:{ },
  watch:{ },
  created(){
    this.getRecordName()
    let lang = window.localStorage.getItem('lang') || 'zh-CN'
    this.lang = lang
  },
  mounted() {
    startBg('#canvas')
    this.initAnimate()
  },
  methods:{
    handleLang () {
      // console.log(this.isLang)
      this.isLang = !this.isLang
    },
    handleChangeLang (e) {
      window.localStorage.setItem('lang', e)
      if (e == 'zh-CN') {
        location.reload()
      }
      // this.__patch__(null, e)
    },
    async getRecordName() { 
      this.$axios.get(this.adminUrlAddr+"/admin/config/query/SYS_COPYRIGHT").then(res => {
        // console.log(res.data);
        if(res.data.code==200){
          this.versionMsg = res.data.data
        }else if(res.data.code==500){
          this.msg.warn(res.data.msg)
          return
        }
      });
      // const {
      //   data,
      //   msg,
      //   code
      // } = await this.$axios.get(this.adminUrlAddr+'/admin/config/query/SYS_COPYRIGHT')
      // if (code !== 200) {
      //   // return this.$message.error(msg)
      //   return
      // }
      // this.versionMsg = data
    },
    /**
     * @Description 星星闪动动画
     * @Author      YOYO     -             2022-01-04
     * @return      {[type]} [description]
     */
    initAnimate () {
      this.iterative = true
      this.timer_inter && clearInterval(this.timer_inter)
      this.timer_inter = setInterval(() => {

        this.iterative = false

        this.timer_setTime && clearTimeout(this.timer_setTime)
        this.timer_setTime = setTimeout(() => {
          this.iterative = true
        })
      }, 14000)
    }
  },
  destroyed () {
    this.timer_setTime && clearTimeout(this.timer_setTime)
    this.timer_inter && clearInterval(this.timer_inter)
  }
}
</script>

<style lang="scss" scoped>
.loginContainer {
  height: 100%;
  min-height: 750px;
  position: relative;
  background: #0A1532 url('./../../assets/img/login/lg-bg.jpg');
  background-size: 100% 100%;

  .lang-box {
    position: absolute;
    top: 20px;
    right: 20px;
    img {
      width: 40px;
    }
  }
  #canvas {
    width: 100%;
    height: 78%;
  }
  .line-box {
    width: 1200px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -600px;
    margin-top: -330px;
    background: url(./../../assets/img/login/line.png) no-repeat;
    background-size: 1100px 358px;
    // border: 1px solid red;
    background-position: 0 center;

    img {
      position: absolute;
      &:nth-child(1) {
        bottom: 40px;
        left: -80px;
        width: 100px;
      }
      &:nth-child(2) {
        bottom: 200px;
        left: 80px;
        width: 63px;
      }
      &:nth-child(3) {
        bottom: 215px;
        left: 202px;
        width: 107px;
      }
      &:nth-child(4) {
        bottom: 200px;
        right: 228px;
        width: 87px;
      }
      &:nth-child(5) {
        top: 172px;
        right: 55px;
        width: 87px;
      }
      &:nth-child(6) {
        top: 50px;
        right: 120px;
        width: 99px;
      }
    }
    &.active {
      img {
        animation: start 2s ease-in;
        &:nth-child(1) {
          animation-delay: 0s;
        }
        &:nth-child(2) {
          animation-delay: 2s;
        }
        &:nth-child(3) {
          animation-delay: 4s;
        }
        &:nth-child(4) {
          animation-delay: 6s;
        }
        &:nth-child(5) {
          animation-delay: 8s;
        }
        &:nth-child(6) {
          animation-delay: 10s;
        }      
      }
    }

  }
  .login-main-box {
    // border: 1px solid red;
    width: 480px;
    height: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -240px;
    margin-top: -275px;
    // margin-top: -315px;
  }
  .footer {
    width: 100%;
    height: 60px;
    text-align: center;
    position: fixed;
    bottom: 30px;
    left: 0px;
    p:nth-child(1) {
      font-size: 18px;
      font-weight: 400;
      color: #94D6D4;
      line-height: 4px;
      span {
        padding: 0 15px;
        letter-spacing: 1px;
      }
      .lst {
        transform: rotate(180deg);
      }
    }
    p:nth-child(2) {
      color: rgba(255,255,255,.6);
      margin-top: 20px;
    }
  }
  // background:no-repeat url(../../assets/img/homePage/loginBg.jpg);
  // background-size: 100% 100%;
  // .login_top{
  //   position: absolute;
  //   width: 100%;
  //   height: 110px;
  //   top: 0;
  //   left: 0;
  //   background: no-repeat url(../../assets/img/login/login_top.png);
  //   background-size: 100% 100%;
  //   text-align: center;
  //   .title{
  //     font-size: 32px;
  //     // color: #01ABFF;
  //     line-height: 54px;
  //     padding-top:24px;
  //     font-weight: 500;
  //     color: #6EE9FF;
  //     line-height: 45px;
  //     letter-spacing: 1px;
  //     font-family: PingFangSC-Medium, PingFang SC;
  //     background: linear-gradient(180deg, #01ABFF 0%, #56DEFE 100%);
  //     -webkit-background-clip: text;
  //     -webkit-text-fill-color: transparent;
  //   }
  // }
  // .left {
  //   width: 100%;
  //   height: 100%;
  //   padding-right:710px;
  //   box-sizing: border-box;
  //   .imgBox {
  //     position: relative;
  //     overflow: hidden;
  //     width: 100%;
  //     height: 100%;
  //     img {
  //       position: absolute;
  //       width:1050px;
  //       height:750px;
  //       top: 50%;
  //       left:50%;
  //       transform: translate(-51%,-45%);
  //     }
  //   }
  // }
  // .right {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   width: 710px;
  //   height: 100%;
  //   border: 1px solid red;
  //  //  text-align: center;
  //  //  background: #3464E1 url('../../assets/img/loginBgRight.png') 50% 50%;
  //   background-size: 100% 100%;
  //   .rightMain{
  //    position: absolute;
  //     left: 0;
  //     top: 0;
  //     // padding: 300px 25px 25px;
  //     box-sizing: border-box;
  //     width: 100%;
  //     height: 100%;
  //     z-index: 100;
  //   }

  // }
  // .bottom {
  //   position: absolute;
  //   left: 0;
  //   bottom: 15px;
  //   padding:0 20px;
  //   width: 100%;
  //   height: 18px;
  //   z-index: 1;
  //   box-sizing: border-box;
  //   .line{
  //     width: 100%;
  //     height: 100%;
  //     background: no-repeat url(../../assets/img/login/login_bottom.png);
  //     background-size: 100% 100%;
  //   }
  // }
  // .company {
  //   // height: 46px;
  //   // line-height: 46px;
  //   position: absolute;
  //   bottom: 20px;
  //   width: 100%;
  //   text-align: center;
  //   font-size: 14px;
  //   color: #9A9CB1;
  //   z-index: 10;
  //   // background-color: rgba(0, 0, 0, 0.6);
  //   .cNum{
  //     font-size: 13px;
  //     cursor: pointer;
  //   }
  // }
}
@keyframes start {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
